/*
  File: italiansecret-stock-guard-config.js
  Purpose: Runtime toggle for stock guard features (grid + checkout).
  Keep in sync with config.env.
*/

window.IS_STOCK_GUARD_ENABLED = true;
window.IS_STOCK_GUARD_URL = "https://storage.googleapis.com/italiansecretweb/availability.json";
window.IS_STOCK_GUARD_TIMEOUT_MS = 4000;
